export const assessmentTemplate = [
  {
    _id: "00031",
    omniAudit: {
      auditVersion: "1",
      omniRevision: "1",
      omniSchema: "assessmentTemplate",
      omniSchemaVersion: "1",
      writtenBy: null,
      createdBy: "Mmigliuri",
      createdDate: "2022-03-015T00:00:00Z",
      modifiedBy: null,
      modifiedDate: null,
      isActive: true,
    },
    omniData: {
      omniType: "phq9",
      omniTypeVersion: 1,
      title: "PHQ-9",
      purpose: "Depression Scale",
      description:
        "The nine-item Patient Health Questionnaire depression scale (PHQ-9) is established as a valid diagnostic and severity measure for depressive disorders in large clinical studies. Our objectives were to assess the PHQ-8 as a depression measure in a large, epidemiological population-based study, and to determine the comparability of depression as defined by the PHQ-9 diagnostic algorithm vs. a PHQ-9 cutpoint > or = 10.",
      duration: "About 20 minutes",
      directions:
        "Over the <b>last 2 weeks</b>, how often have you been bothered by any of the following problems? Select one option for each question",
      attribution:
        "PHQ-9 is adapted from PRIME MD TODAY, developed by Drs Spitzer, Williams, Kroenke and colleagues, with an educational grant from Pfizer Inc. Use of the PHQ-9 may only be made in accordance with the Terms of Use available at www.pfizer.com. Copyright © 1999 Pfizer Inc. All rights reserved. PRIME MD TODAY is a trademark of Pfizer Inc.",
      validated: "true",
      selfAssessment: false,
      startDate: null,
      completeDate: null,
      questions: [
        {
          omniID: "PHQ91",
          shortTitle: "subjectApathyRank",
          numberText: "1",
          text: "How often during the past 2 weeks were you bothered by little interest or pleaure in doing things?",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the answer that most closely applies",
          answerOptions: [
            {
              value: "0",
              text: "Not at all",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Several days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "More than half the days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "Nearly every day",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "PHQ92",
          shortTitle: "subjectDepressionRank",
          numberText: "2",
          text: "How often during the past 2 weeks were you bothered by feeling down, depressed, or hopeless?",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the answer that most closely applies",
          answerOptions: [
            {
              value: "0",
              text: "Not at all",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Several days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "More than half the days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "Nearly every day",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "PHQ93",
          shortTitle: "subjectInsomniaRank",
          numberText: "3",
          text: "How often during the past 2 weeks were you bothered by trouble falling or staying asleep, or sleeping too much?",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the answer that most closely applies",
          answerOptions: [
            {
              value: "0",
              text: "Not at all",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Several days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "More than half the days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "Nearly every day",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "PHQ94",
          shortTitle: "subjectLethargyRank",
          numberText: "4",
          text: "How often during the past 2 weeks were you bothered by feeling tired or having little energy?",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the answer that most closely applies",
          answerOptions: [
            {
              value: "0",
              text: "Not at all",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Several days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "More than half the days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "Nearly every day",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "PHQ95",
          shortTitle: "subjectAppetiteRank",
          numberText: "5",
          text: "How often during the past 2 weeks were you bothered by poor appetite or overeating?",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the answer that most closely applies",
          answerOptions: [
            {
              value: "0",
              text: "Not at all",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Several days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "More than half the days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "Nearly every day",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "PHQ96",
          shortTitle: "subjectSelfWorthRank",
          numberText: "6",
          text: "How often during the past 2 weeks were you bothered by feeling bad about yourself, or that you are failure, or have let yourself or your family down?",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the answer that most closely applies",
          answerOptions: [
            {
              value: "0",
              text: "Not at all",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Several days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "More than half the days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "Nearly every day",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "PHQ97",
          shortTitle: "subjectDistractionRank",
          numberText: "7",
          text: "How often during the past 2 weeks were you bothered by trouble concentrating on things, such as reading the newspaper or watching television?",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the answer that most closely applies",
          answerOptions: [
            {
              value: "0",
              text: "Not at all",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Several days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "More than half the days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "Nearly every day",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "PHQ98",
          shortTitle: "subjectEnergyRank",
          numberText: "8",
          text: "How often during the past 2 weeks were you bothered by moving or speaking so slowly that other people could have noticed? Or the opposite - being so fidgety or restless that you have been moving around a lot more than usual?",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the answer that most closely applies",
          answerOptions: [
            {
              value: "0",
              text: "Not at all",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Several days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "More than half the days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "Nearly every day",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "PHQ99",
          shortTitle: "subjectSuicidalIdeationRank",
          numberText: "9",
          text: "How often during the past 2 weeks were you bothered by thoughts that you would be better off dead or of hurting yourself in some way?",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the answer that most closely applies",
          answerOptions: [
            {
              value: "0",
              text: "Not at all",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Several days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "More than half the days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "Nearly every day",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "PHQ910",
          shortTitle: "subjectEffectRank",
          numberText: "10",
          text: "If you checked off any problems, how difficult have these problems made it for you to do your work, take care of things at home, or get along with other people?",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the answer that most closely applies",
          answerOptions: [
            {
              value: "Not difficult at all",
              text: "Not difficult at all",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: "Somewhat difficult",
              text: "Somewhat difficult",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: "Very difficult",
              text: "Very difficult",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: "Extremely difficult",
              text: "Extremely difficult",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
      ],
      assessmentResults: {
        finalResult: null,
        finalDifficultyRating: null,
      },
    },
  },
];
export const assessmentScoring = [
  {
    typeID: "phq9",
    algorithms: [
      {
        name: "sum",
        minScore: 0,
        maxScore: 27,
        formula: null,
        questions: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      },
    ],
  },
];
